/*!
 * jQuery Custom-form-elements plugin
 * Author: Globalia
 * Licensed under the WTFPL license
 */

// Parsley validation
// --------------------------------------------------

( function( $ ) {

    'use strict';

    $('[gr-form]').length && $('[gr-form]').parsley({
        trigger:      'change',
        errorClass: "parsley-error",
        classHandler: function (el) {
            return el.$element.closest('[gr-form~=field]');
        },
        errorsContainer: function(pEle) {
            var $err = pEle.$element.closest('[gr-form~=field]').append();
            return $err;
        }
    });

    if (document.documentElement.lang === 'fr') {
        require('../../../../node_modules/parsleyjs/dist/i18n/fr.js');
    }

} )( require('jquery'), require('../../../../node_modules/parsleyjs/dist/parsley.min.js') );
